import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-caf-login',
  templateUrl: './caf-login.component.html',
  styleUrls: ['./caf-login.component.css']
})
export class CafLoginComponent implements OnInit, AfterViewInit, OnDestroy {

  verPassword = false;
  isLogged = false;

  form: FormGroup = new FormGroup({
    password: new FormControl('', Validators.required),
  });
  cargando = false;


  modalLogin: any;
  modalRegister: any;

  isBrowser: boolean;

  constructor(private auth: AuthService, private router: Router,
    @Inject(PLATFORM_ID) platformId) {

    this.isBrowser = isPlatformBrowser(platformId);
  }

  async ngAfterViewInit() {
    if (this.isBrowser) {
      this.modalLogin = $('#modalLogin');
      this.modalRegister = $('#modalRegister');

      if (!this.auth.estaAutenticado()) {
        console.log("Abrir modal")
        this.abrirModal(this.modalLogin);
      }
    }
  }


  ngOnInit(): void {

    this.auth.logged$.subscribe((status) => {
      this.isLogged = status;
      console.log("Login status", status)

      if (this.isLogged) {
        this.validateCafToken();
      } else {
        this.auth.logoutCaf();
        console.log("Abrir modal")
      }
    });
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.

    if (this.modalLogin) this.modalLogin.modal('hide');
    if (this.modalRegister) this.modalRegister.modal('hide');
  }

  onSubmit() {
    if (this.form.valid) {
      let password = this.form.value.password;
      console.log("passw", this.form.value.password);
      this.cargando = true;

      this.auth.loginCaf(password).then(resp => {
        console.log("RESP")
        this.cargando = false;

        if (resp) this.router.navigateByUrl("/caf")
      })
    }
  }


  alternarVerPassword(idElement: string = null) {
    if (idElement) {
      let propiedad = 'ver' + idElement.charAt(0).toUpperCase() + idElement.slice(1);

      this[propiedad] = !this[propiedad];
      let elemento: any = document.getElementById(idElement);

      if (elemento) {
        elemento.type = this[propiedad] ? 'text' : 'password';
      }
    }
  }

  validateCafToken() {
    let cafToken = this.auth.getCafToken();

    if (cafToken) {
      this.router.navigateByUrl('caf');
    }
  }

  //#region auth
  onLogin(respuesta) {
    if (respuesta) {
      this.modalLogin.modal('hide');
    }
  }

  onRegister(respuesta) {
    if (respuesta) this.modalRegister.modal('hide');
  }
  //#endregion

  /**
 * Abre modal declarado, se pasa por parámetro el identificador del DOM o el objeto modal
 * @param modal String || Object
 */
  abrirModal(modal: any) {
    this.modalLogin.modal('hide');
    this.modalRegister.modal('hide');

    if (modal) {
      if (typeof modal === 'string') this[modal].modal('show');
      if (typeof modal === 'object') modal.modal('show');
    }
  }
} 
